import React from 'react';

const VideoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    height="37"
    viewBox="0 0 29 37"
    width="29"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M6 36.9531H22.2857C25.5994 36.9531 28.2857 34.2668 28.2857 30.9531V6.95312C28.2857 3.63942 25.5994 0.953125 22.2857 0.953125H6C2.68629 0.953125 0 3.63942 0 6.95313V30.9531C0 34.2668 2.68629 36.9531 6 36.9531Z"
      fill="url(#paint0_linear_4127_88474)"
    />
    <mask
      height="37"
      id="mask0_4127_88474"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
      width="29"
      x="0"
      y="0">
      <path
        d="M0 6.95313C0 3.63942 2.68629 0.953125 6 0.953125H22.2857C25.5994 0.953125 28.2857 3.63942 28.2857 6.95312V30.9531C28.2857 34.2668 25.5994 36.9531 22.2857 36.9531H6C2.68629 36.9531 0 34.2668 0 30.9531V6.95313Z"
        fill="url(#paint1_linear_4127_88474)"
      />
    </mask>
    <g mask="url(#mask0_4127_88474)">
      <path
        d="M10.5 23.6495C10.5 24.2265 11.1243 24.5874 11.6243 24.2994L19.1326 19.9749C19.6335 19.6864 19.6335 18.9636 19.1326 18.6751L11.6243 14.3507C11.1243 14.0627 10.5 14.4236 10.5 15.0006V23.6495Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_4127_88474"
        x1="14.1429"
        x2="14.1429"
        y1="0.953125"
        y2="36.9531">
        <stop stopColor="#57B1FF" />
        <stop offset="1" stopColor="#2B8FE6" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_4127_88474"
        x1="14.1429"
        x2="14.1429"
        y1="0.953125"
        y2="36.9531">
        <stop stopColor="#57B1FF" />
        <stop offset="1" stopColor="#21C2E6" />
      </linearGradient>
    </defs>
  </svg>
);

export default VideoIcon;
